import React from "react";
import * as styles from "./ctaSection.module.css";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import CTAButton from "../cta-button/ctaButton";
import ChooseButton from "../choose-button/chooseButton";

export default ({ node }) => {
  const { headText, subHeadText, image, text, chooseButtons, actionButton } =
    node;
  // let sectionImg = [];
  // let index = 0;
  // if (image && image.asset) {
  //   sectionImg[index] = image.asset.url;
  // }
  let sectionImg = [];
  let index = 0;
  if (typeof index === `object`) {
    for (const img of image) {
      if (img && img.asset) {
        sectionImg[index] = img.asset.url;
        index++;
      }
    }
  }

  return (
    <Box className={styles.ctaSectionBox}>
      <Box pl={{ xs: 2, sm: 2, md: 4 }} pr={{ xs: 2, sm: 2, md: 4 }}>
        <Grid container>
          <Grid item xs={12}>
            <h2 className={styles.ctaSectionHeadText}>{headText}</h2>
          </Grid>
          <Grid item xs={12} className={styles.ctaSectionQuizGrid}>
            <Box mb={2}>
              <h2 className={styles.ctaSectionSubHeadText}>{subHeadText}</h2>
            </Box>
            {/* {sectionImg ? (
              <Box mb={2} className={styles.ctaSectionMediaBox}>
                <img src={sectionImg} className={styles.ctaSectionImg} />
              </Box>
            ) : null} */}

            {sectionImg && sectionImg.length > 0 ? (
              <Box mb={2} className={styles.ctaSectionMediaBox}>
                <Grid container>
                  {sectionImg.map((item) => {
                    return (
                      <Grid xs={12} sm={6} md={4}>
                        <img
                          src={item}
                          className={styles.ctaSectionImg}
                        />
                      </Grid>
                    );
                  })}
                </Grid>
              </Box>
            ) : null}

            <Box mb={2}>
              <h2 className={styles.ctaSectionText}>{text}</h2>
            </Box>
            {chooseButtons && chooseButtons.length > 0 ? (
              <Box mb={2} className={styles.chooseButtonsBox}>
                {chooseButtons.map((item) => {
                  return <ChooseButton node={item} />;
                })}
              </Box>
            ) : null}
            <Box mb={2} className={styles.actionButtonBox}>
              <CTAButton node={actionButton} />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};
